@if (
  {
    isOccupationInFavorites: isOccupationInFavorites$ | async,
    shouldDisable: shouldDisable$ | async
  };
  as data
) {
  @if (data.isOccupationInFavorites) {
    <cpd-stroked-button
      id="fav-button"
      fontSet="fas"
      fontIcon="bookmark"
      color="secondary"
      size="small"
      backgroundColor="solid"
      ariaLabel="Remove this occupation from your saved list"
      [disabled]="data.shouldDisable"
      (click)="onRemoveFavoriteOccupation($event)"
    >
    </cpd-stroked-button>
  } @else {
    <cpd-stroked-button
      id="fav-button"
      fontSet="fal"
      fontIcon="bookmark"
      color="secondary"
      size="small"
      backgroundColor="solid"
      ariaLabel="Save this occupation for later"
      [disabled]="data.shouldDisable"
      [matTooltip]="
        data.shouldDisable
          ? 'You can only save up to 3 occupations for later. Please unselect one of your current selections to save this one.'
          : ''
      "
      (click)="onAddFavoriteOccupation($event, data.shouldDisable)"
    >
    </cpd-stroked-button>
  }
}
